export enum ConfigurationAccordions {
  HEAD_GRAFTS = "hair-grafts",
  PRP_OR_MESOTHERAPY_ONLY = "prp-or-mesotherapy-only",
  BEARD_GRAFTS = "beard-grafts",
  EYEBROW_GRAFTS = "eyebrow-grafts",
}
